import React, { useContext, useEffect, useState } from 'react';
import { Sidebar } from 'semantic-ui-react';
import { ParentContext } from '../../cnr/contexts/ParentContext';
import { gEnums } from '../../enums/globalEnums';
import _ from 'lodash';

const DataSidebar = (props) => {

  const { visible, content, onHide, direction, width, cn } = props;

  // parentContext
  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {};
  const { currentSettings_state } = states;
  const { aps_styles } = _.get(currentSettings_state, 'gvviSettings', {});
  const styleAndClass = aps_styles?.[gEnums?.projectStyles?.actionItems] ?? { style: {} };

  if (styleAndClass) {
    styleAndClass.className = direction === 'left' ? 'sbl' : 'sbr';
  }

  // --- internal state to prevent immediate onHide ---
  const [allowClose, setAllowClose] = useState(true);

  useEffect(() => {
    if (visible) {
      setAllowClose(false);
      const timer = setTimeout(() => setAllowClose(true), 2000); // 200ms grace period
      return () => clearTimeout(timer);
    }
  }, [visible]);

  const handleHide = () => {
    if (!allowClose) return; // ignore premature hide
    onHide?.(); // call the parent onHide
  };

  return visible ? (
    <Sidebar
      {...styleAndClass}
      animation="overlay"
      direction={direction ?? 'left'}
      icon="labeled"
      visible={visible}
      width={width ?? 'very wide'}
      className={`vsr-container dsb ${cn ?? ''}`}
      onHide={handleHide}
    >
      {content}
    </Sidebar>
  ) : (
    <div className={styleAndClass?.className}></div>
  );
};

export default DataSidebar;
